module.exports = __webpack_public_path__ + "static/img/590.455a711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/590.jpg
// module id = Sys5
// module chunks = 0